export var Brands;
(function (Brands) {
    Brands["VW"] = "VW";
    Brands["VWN"] = "VWN";
    Brands["Audi"] = "Audi";
})(Brands || (Brands = {}));
export var CheckoutType;
(function (CheckoutType) {
    CheckoutType["BUILD_TO_ORDER"] = "BUILD_TO_ORDER";
    CheckoutType["BUILD_TO_STOCK"] = "BUILD_TO_STOCK";
    CheckoutType["STOCK_CAR_SALES"] = "STOCK_CAR_SALES";
})(CheckoutType || (CheckoutType = {}));
export var FinancialProducts;
(function (FinancialProducts) {
    FinancialProducts["ONLINE_LEASING"] = "ONLINE_LEASING";
    FinancialProducts["CASH"] = "CASH";
    FinancialProducts["FINANCING"] = "FINANCING";
    FinancialProducts["RESERVATION"] = "RESERVATION";
})(FinancialProducts || (FinancialProducts = {}));
export var VehicleType;
(function (VehicleType) {
    VehicleType["MARKETING_CODE"] = "MARKETING_CODE";
    VehicleType["VTP_CARID"] = "VTP_CARID";
})(VehicleType || (VehicleType = {}));
export var VehicleCondition;
(function (VehicleCondition) {
    VehicleCondition["USED_CAR"] = "USED_CAR";
    VehicleCondition["NEW_CAR"] = "NEW_CAR";
})(VehicleCondition || (VehicleCondition = {}));
export var BusinessModel;
(function (BusinessModel) {
    BusinessModel["DEALER_STOCK"] = "dealer_stock";
    BusinessModel["NSC_STOCK"] = "nsc_stock";
    BusinessModel["AGENCY_STOCK"] = "agency_stock";
})(BusinessModel || (BusinessModel = {}));
//# sourceMappingURL=type.js.map